// extracted by mini-css-extract-plugin
export default {"event":"EventItem_event__Ot2Fx","event_name":"EventItem_event_name__mW56m"};